import SigliveServiceV3 from 'Service/sigliveServiceV3';

const getBrandList = async (queries = '') => {
  const { data } = await SigliveServiceV3({ method: 'GET', url: `/target/brand/list?${queries}` });

  return data?.data;
};

export default getBrandList;
